// src/services/testAfiliadosApi.js
// Cliente para el módulo de afiliados de prueba (solo SuperAdmin).

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5246';

function tok() { return localStorage.getItem('ecolab_token') || null; }

async function apiGet(path) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { Authorization: `Bearer ${tok()}` },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.mensaje || `GET ${path} → ${res.status}`), { data, status: res.status });
  return data;
}

async function apiSend(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tok()}` },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.mensaje || `${method} ${path} → ${res.status}`), { data, status: res.status });
  return data;
}

export const getRangoTest       = () => apiGet('/api/ecolab/admin/test-afiliados/rango');
export const listarTestAfiliados = () => apiGet('/api/ecolab/admin/test-afiliados');
export const crearBatchTest     = (dto) => apiSend('POST', '/api/ecolab/admin/test-afiliados/crear-batch', dto);
export const limpiarTodoTest    = () => apiSend('DELETE', '/api/ecolab/admin/test-afiliados/limpiar-todo');

// Constantes (deben coincidir con TestData.cs del backend)
export const TEST_RANGO_INICIO = 2100000000;
export const TEST_RANGO_FIN    = 2100000099;

export function esCedulaTest(documento) {
  if (!documento) return false;
  const n = parseInt(String(documento).trim(), 10);
  if (Number.isNaN(n)) return false;
  return n >= TEST_RANGO_INICIO && n <= TEST_RANGO_FIN;
}
